var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"superbets__manual-filter"},[_vm._v(" MarketTypesFilter.vue ")])}
var staticRenderFns = []

export { render, staticRenderFns }